export default __webpack_public_path__ + "48e97ec73f48d9a593238bcb8764eac5.png";